import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchStaffCountAsync } from "../thunks/staffCountThunk";

interface StaffCountData {
  activeStaff: number;
  conflictingStaff: number;
  pendingStaff: number;
  totalStaff: number;
}

interface StaffCountState {
  staffCount: StaffCountData | null;
  loading: boolean;
  error: string | null;
}
const initialStaffCountState: StaffCountState = {
  staffCount: null,
  loading: false,
  error: null,
};

const staffCountSlice = createSlice({
  name: "staffCount",
  initialState: initialStaffCountState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchStaffCountAsync.pending, (state) => {
        state.loading = true; // Set loading to true when fetching starts
        state.error = null; // Reset error state
      })
      .addCase(fetchStaffCountAsync.fulfilled, (state, action) => {
        state.staffCount = action.payload;
        state.loading = false; // Set loading to false when fetching is successful
      })
      .addCase(fetchStaffCountAsync.rejected, (state, action) => {
        state.loading = false; // Set loading to false when fetching fails
        state.error = action.error.message ?? null; // Update error state
      });
  },
});

// export const { fetchUserDetailsLoading, fetchUserDetailsSuccess, fetchUserDetailsFailure } = userDetailsSlice.actions;
export default staffCountSlice.reducer;
